<div class="facebook-settings" [formGroup]="form">
  <div class="facebook-settings__field">
    <label class="facebook-settings__label">Upload type</label>
    <icn-dropdown
      class="facebook-settings__dropdown"
      [large]="true"
      [allowMultiple]="false"
      [listDown]="true"
      [disabled]="readonly"
      [selectedValue]="form.controls.publishTarget.value"
      (selectedValueChange)="onPublishTargetChange($event)"
    >
      <icn-dropdown-item
        *ngFor="let option of facebookPublishTargets"
        [value]="option.value"
        [title]="option.label"
        [selectable]="isPublishTargetSelectable(option.value)"
      ></icn-dropdown-item>
    </icn-dropdown>
    <p *ngIf="!reelsEligible" class="facebook-settings__helper">
      Page Reel is disabled because this Facebook Page is not Reels-eligible.
    </p>
  </div>

  <ng-container *ngIf="isPageVideoTarget">
    <div class="facebook-settings__field">
      <label class="facebook-settings__label">Content category</label>
      <icn-dropdown
        class="facebook-settings__dropdown facebook-settings__dropdown--category"
        [large]="true"
        [allowMultiple]="false"
        [listDown]="true"
        [disabled]="readonly"
        [selectedValue]="contentCategorySelection"
        (selectedValueChange)="onContentCategoryChange($event)"
      >
        <icn-dropdown-item
          [value]="facebookContentCategoryNone"
          title="None"
        ></icn-dropdown-item>
        <icn-dropdown-item
          *ngFor="let option of facebookContentCategories"
          [value]="option.value"
          [title]="option.label"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="facebook-settings__field">
      <mat-checkbox
        formControlName="embeddable"
        class="facebook-settings__checkbox"
        [disableRipple]="true"
      >
        Embeddable
      </mat-checkbox>
      <mat-checkbox
        formControlName="noStory"
        class="facebook-settings__checkbox"
        [disableRipple]="true"
      >
        No story
      </mat-checkbox>
    </div>
  </ng-container>
</div>
